// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"4af16027","262":"57a38828","498":"0fb0c23e"}[chunkId] + ".chunk.css";
};